import { Block, Columns, Hint, Indicator, Info, LocalizedText, Logo, Rows, SortedTable } from 'labguard-cdk'
import React from 'react'
import { ChannelIcon, CertificateIcon, VersionIcon, CalendarAltIcon } from 'src/components/common/icons'
import { PageOptionsPortal } from 'src/components/common'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import isNil from 'lodash/isNil'
import UserManualDownloadButton from './UserManualDownloadButton'

const query = gql`
  query about {
    products
    version
    license
    maxChannelCount
    remainingDays
  }
`

const columns = [
  {
    dataKey: 'label',
    width: 100,
    flexGrow: 1,
    flexShrink: 1,
    label: <LocalizedText id="WEB_INSTALLED_PRODUCTS" />,
    cellDataGetter: ({ rowData }) => rowData,
  },
]

export default function Home() {
  const { loading, data: { products = [], version, license, maxChannelCount, remainingDays } = {} } = useQuery(query)
  return (
    <>
      <PageOptionsPortal justify="start">
        <UserManualDownloadButton />
      </PageOptionsPortal>
      <Rows layout="auto" align="center" justify="space-around">
        <Logo style={{ width: '200px', height: '200px' }} />
        <Rows>
          <Columns layout="500px 200px" gap="1rem" justify="center">
            <Hint>
              <Info label={<LocalizedText id="WEB_USERS_NOTICE" />} color="primary">
                <LocalizedText id="WEB_PRODUCT_WARNING" />
              </Info>
            </Hint>
            <Block padding="0">
              <SortedTable loading={loading} data={products} columns={columns} />
            </Block>
          </Columns>
        </Rows>
        <Columns gap="2rem">
          <Indicator
            color="primary"
            icon={CertificateIcon}
            subtitle={<LocalizedText id="WEB_LICENSE" />}
            title={license}
          />
          <Indicator
            color="primary"
            icon={VersionIcon}
            subtitle={<LocalizedText id="WEB_VERSION_NUMBER" />}
            title={version}
          />
          <Indicator
            color="primary"
            icon={ChannelIcon}
            subtitle={<LocalizedText id="WEB_CHANNEL_TOTAL_NUMBER" />}
            title={isNil(maxChannelCount) ? <LocalizedText id="WEB_UNLIMITED" /> : maxChannelCount}
          />
          <Indicator
            color="primary"
            icon={CalendarAltIcon}
            subtitle={<LocalizedText id="WEB_REMAINING_DAYS" />}
            title={isNil(remainingDays) ? <LocalizedText id="WEB_SAVED_VERSION" /> : remainingDays}
          />
        </Columns>
      </Rows>
    </>
  )
}
